export const API_GET_GENERATED_ORDERS = "API_GET_GENERATED_ORDERS"
export const RESET_GENERATED_ORDERS = "RESET_GENERATED_ORDERS"
